import styled, { css } from 'styled-components';
import enabled from '~/components/svg-icon/images/ic-24-radio-enabled.svg';
import radioSelected from '~/components/svg-icon/images/ic-24-radio-selected.svg';
import checkOff from './images/ic_24_checkbox_checked.svg';
import checkOn from './images/ic_24_checkbox_enabled.svg';
import selectDown from './images/ic_24_arrow_down_gray500.svg';

export const Wrap = styled.div`
  padding: 38px 45px 80px;
  position: relative;
  background-color: #F6FCFD;

  @media only screen and (max-width: 425px) {
    padding: 38px 28px 80px;
  }
`;

export const Box = styled.div`
  margin: 56px 0px;
  padding: 5px;
  border: 2px solid #8F9192;
  border-radius: 7px;

  > div {
    background: #FFFFFF;
    border-width: 0px 2px 2px 2px;
    border-style: solid;
    border-color: #181818;
    border-radius: 4px;
  }
`;

export const TextBox = styled.div`
  padding: 40px;

  > label {
    display: flex;
    align-items: center;
    margin-top: 34px;

    > input {
      flex: none;
      width: 32px;
      height: 32px;
      margin: 0;
      margin-right: 8px;
      border: 0;
      border-radius: 0;
      background-image: url(${enabled}) ;
      background-size: cover;
      appearance: none;
      cursor: pointer;

      &:checked {
        background-image: url(${radioSelected});
      }

      @media only screen and (max-width: 425px) {
        width: 24px;
        height: 24px;
      }
    }

    > p {
      font-size: 22px;
      line-height: 38px;
      font-weight: 400;

      @media only screen and (max-width: 425px) {
        font-size: 14px;
        line-height: 24px;
        font-weight: 400;
      }
    }
  }

  > label:first-child {
    margin-top: 0;
  }
`;

export const TextInput = styled.input`
  width: 100%;
  height: 72px;
  padding: 10px 16px;
  margin-bottom: 34px;
  border: 1px solid #EDEDED;
  border-radius: 2px;
  font-size: 22px;
  font-weight: 400;
  line-height: 38px;
  box-sizing: border-box;
  -webkit-appearance: none;

  @media only screen and (max-width: 425px) {
    font-size: 14px;
    line-height: 24px;
    font-weight: 400;
  }
`;

export const InputBox = styled.div`
  padding: 40px;

  > p {
    margin-bottom: 8px;
    color: black;
    font-size: 22px;
    font-weight: 400;
    line-height: 38px;

    @media only screen and (max-width: 425px) {
      font-size: 14px;
      line-height: 24px;
      font-weight: 400;
    }
    
    > span {
      margin-left: 4px;
      color: blue;
      font-size: 22px;
      font-weight: 400;
      line-height: 38px;

      @media only screen and (max-width: 425px) {
        font-size: 14px;
        line-height: 24px;
        font-weight: 400;
      }
    }
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 74px;
  margin-top: 16px;
  padding: 10px 0 10px 16px;
  border: 1px solid #EDEDED;
  border-radius: 2px;
  font-size: 22px;
  font-weight: 400;
  line-height: 38px;
  box-sizing: border-box;
  color: #979797;
  -webkit-appearance: none;

  &:disabled {
    color: #CCCCCC;
  }

  @media only screen and (max-width: 425px) {
    font-size: 14px;
    line-height: 24px;
    font-weight: 400;
  }
`;

export const TextLabel = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 34px;
  flex-wrap: wrap;

  > label {
    display: flex;
    align-items: center;

    > input {
      width: 32px;
      height: 32px;
      margin: 0;
      margin-right: 8px;
      border: 0;
      border-radius: 0;
      background-image: url(${enabled}) ;
      background-size: cover;
      appearance: none;
      cursor: pointer;

      &:checked {
        background-image: url(${radioSelected});
      }

      @media only screen and (max-width: 425px) {
        width: 24px;
        height: 24px;
      } 
    }
  }

  > label + label {
    margin-left: 20px;
  }
`;

export const SelectStd = css`
  padding: 18px 16px;
  border: 1px solid #EDEDED;
  border-radius: 2px;
  font-size: 22px;
  font-weight: 400;
  line-height: 38px;
  color: #979797;
  background-image: url(${selectDown});
  background-position: right 10px center;
  background-repeat: no-repeat;
  appearance: none;
  box-sizing: border-box;

  @media only screen and (max-width: 425px) {
    font-size: 14px;
    line-height: 24px;
    font-weight: 400;
  }
`;

export const Select = styled.select`
  width: 100%;
  height: 74px;
  ${SelectStd}
  margin-bottom: 34px;
`;

export const SelectWrap = styled.div`
  display: flex;

  > select {
    flex: none;
    width: calc(50% - 8px);
    height: 74px;
    ${SelectStd}
  }

  > select:last-child {
    margin-left: 16px;
  }
`;

export const AgreeWrap = styled.div`
  padding: 6px;
  margin-bottom: 40px;
  background: #FFFFFF;
  border: 2px solid #8F9192;
  border-radius: 7px;
  position: relative;

  > div {
    display: flex;
    flex-direction: column;
    padding: 32px 40px;
    border-radius: 4px;
    border: 2px solid #181818;
    background: #FFFFFF;

    @media only screen and (max-width: 425px) {
      padding: 32px 20px;
    }
  }
`;

export const AgreeCheckBox = styled.label`
  display: flex;
  align-items: center;
  position: relative;

  > input {
    width: 32px;
    height: 32px;
    flex: none;
    margin: 0;
    margin-right: 8px;
    border: 0;
    border-radius: 0;
    background-image: url(${checkOff}) ;
    background-size: cover;
    appearance: none;
    cursor: pointer;

    &:checked {
      background-image: url(${checkOn});
    }

    @media only screen and (max-width: 425px) {
      width: 24px;
      height: 24px;
    }
  }

  > p {
    font-size: 24px;
    font-weight: 700;
    line-height: 38px;

    @media only screen and (max-width: 425px) {
      font-size: 14px;
      line-height: 24px;
      font-weight: 700;
    }
  }
`;

export const AgreeTextBox = styled.div`
  margin-top: 32px;
  padding: 32px;
  background: #F5F5F5;
  border-radius: 4px;

  > div {
    display: flex;
    margin-bottom: 8px;

    > span, p {
      font-size: 24px;
      font-weight: 400;
      line-height: 32px;
      color: #222222;
      opacity: 0.7;

      @media only screen and (max-width: 425px) {
        font-size: 14px;
        line-height: 24px;
        font-weight: 400;
      }
    }
  }

  @media only screen and (max-width: 425px) {
    padding: 24px
  }

  > div:last-child {
    margin-bottom: 0px;
  }
`;

export const BtnWrap = styled.div`
  cursor: pointer;
`;